import React from 'react';

import useOverviewPage from 'hooks/useOverviewPage';
import { TYPER_OVERVIEW_BREADCRUMBS } from 'constants/video';
import ContentLayout from 'components/layout/ContentLayout';
import { useTranslation } from 'react-i18next';
import PerksSection from 'components/common/sections/PerksSection';
import NewsletterSection from 'components/common/sections/NewsletterSection';
import PartnerSliderSection from 'components/common/sections/PartnerSliderSection';
import OffersSection from 'components/common/sections/OffersSection';
import Breadcrumbs from './Breadcrumbs';
import useIsAuthenticated from 'hooks/useIsAuthenticated';
import PresentationOverview from 'components/common/sections/PresentationOverview';

function TyperPage() {
  const { t } = useTranslation();

  const { overviewPage } = useOverviewPage('typer');
  const { isUserLoggedIn } = useIsAuthenticated();

  if (!overviewPage) {
    return null;
  }

  const {
    description,
    thumbnail,
    sponsorings,
    offeringTitle,
    offeringDescription,
    content,
    newsletterTitle,
    newsletterDescription,
  } = overviewPage;

  return (
    <ContentLayout title={t('typer.page.title')}>
      <PresentationOverview
        topComponent={<Breadcrumbs items={TYPER_OVERVIEW_BREADCRUMBS} />}
        title={t('typer.page.title')}
        description={description}
        thumbnail={thumbnail}
        hideButton={isUserLoggedIn}
      />
      <OffersSection title={offeringTitle} description={offeringDescription} topics={content} type={'typer'} />
      <NewsletterSection title={newsletterTitle} description={newsletterDescription} />
    </ContentLayout>
  );
}

export default TyperPage;
